import {
  Container,
  RightColumn,
  Navigation,
  Field,
  Label,
  SelectBox,
  Row,
} from "../../../components";
import { HBLogo } from "../../../components/icons";
import styles from "./styles.module.css";
import i18n from "../../../producers/i18n";
import checkSSnError from "../../../utils/checkSSN";
import * as producers from "./producers";
import checkTelephone from "../../../utils/checkTelephone";
import { TelInput } from "./tel-input";

const SelectBoxWrapper: view = ({
  values,
  currentValue = observe.signingMethod,
  isOpen = observe.views[prop._viewId].data.temp,
  updateValue = update.signingMethod,
  toggleOpen = update.views[prop._viewId].data.temp,
}) => (
  <SelectBox
    values={values}
    currentValue={currentValue}
    isOpen={isOpen}
    updateValue={(value) => updateValue.set(value)}
    toggleOpen={(value) => toggleOpen.set(value)}
  />
);

export const Login: view = ({
  id,
  validSSN = update.views[prop._viewId].validSSN,
  isValidSSN = observe.views[prop._viewId].validSSN,
  validTelephone = update.views[prop._viewId].validTelephone,
  isValidTelephone = observe.views[prop._viewId].validTelephone,
  updateSSN = update.ssn,
  ssn = observe.ssn,
  telephone = observe.telephone,
  updateTelephone = update.telephone,
  signingMethod = observe.signingMethod,
  updateSigningMethod = update.signingMethod,
  isLoginSubmited = update.views[prop._viewId].isLoginSubmited,
}) => {
  if (!signingMethod) {
    updateSigningMethod.set("bankid-se");
  }
  const validate = () => {
    if (ssn) {
      validSSN.set(checkSSnError(ssn, signingMethod));
    }

    if (telephone) {
      validTelephone.set(checkTelephone(telephone));
    }
  };

  return (
    <Container>
      <RightColumn
        withBg={true}
        withHeading={true}
        headingText={i18n.t("login.right_column_heading")}
      >
        <div className={styles.SSNInput}>
          <HBLogo />
          <h2>{i18n.t("login.identityCheckTitle")}</h2>
          <p>{i18n.t("login.identityCheckDescription")}</p>
          <Row>
            <Field>
              <Label>{`${i18n.t("global.verified_secured")}:`}</Label>
              <SelectBoxWrapper
                id={id}
                fieldName="signingMethod"
                fieldTempName="signingMethodSelect"
                values={[
                  { label: "BankID Sweden", value: "bankid-se" },
                  // { label: "SMS + Pin code", value: "sms" },
                  { label: "BankID Norway", value: "bankid-no" },
                  { label: "BankID Finland", value: "bankid-fi" },
                  { label: "EIDs Denmark", value: "nemid-dk" },
                ]}
                onChange={validate()}
              />
            </Field>
            {signingMethod === "bankid-no" && (
              <Field>
                <Label>{`${i18n.t("global.ssn")}:`}</Label>
                <input
                  className={`${styles.input} ${!isValidSSN && styles.invalid}`}
                  type="text"
                  onChange={(e) => {
                    const ssnValue = e.target.value.trim();
                    validSSN.set(checkSSnError(ssnValue, signingMethod));
                    updateSSN.set(ssnValue);
                  }}
                  placeholder={`YYYYMMDDXXXX`}
                />
              </Field>
            )}

            {signingMethod === "sms" && (
              <Field>
                <Label>{`${i18n.t("global.telephone")}:`}</Label>
                <TelInput
                  onChange={(value: string) => {
                    const telephoneValue = value.trim();
                    validTelephone.set(checkTelephone(telephoneValue));
                    updateTelephone.set(telephoneValue);
                  }}
                  placeholder={`Enter Your Telephone Number`}
                  className={`${styles.input} ${
                    !isValidTelephone && styles.invalid
                  }`}
                />
              </Field>
            )}
          </Row>
        </div>
        <Navigation
          isBackActive={false}
          isBackInactive={true}
          isBackMissing={true}
          isNextActive={false}
          isNextInactive={false}
          onBack={() => false}
          onNext={() => {
            if (signingMethod === "sms") {
              if (!isValidTelephone) {
                isLoginSubmited.set(false);
                alert("Please provide valid phone!");
              } else {
                isLoginSubmited.set(true);
              }
            } else if (
              (signingMethod === "bankid-no" && isValidSSN) ||
              signingMethod === "bankid-se" ||
              signingMethod === "bankid-fi" ||
              signingMethod === "nemid-dk"
            ) {
              isLoginSubmited.set(true);
            } else {
              isLoginSubmited.set(false);
              alert("Please provide valid SSN!");
            }
          }}
        />
      </RightColumn>
    </Container>
  );
};

Login.producers(Object.values([producers]));
